// Filename - components/searchbar/SearchbarData.js

// Every entry opens something: apps open their page, the two wired-up
// processes open their homepage modal, and every other task opens the
// generic task page at /task/<slug> (QA issue 1).
export const SearchbarData = [
    {
        title: "Career",
        path: "/career",
        type: "App"
    },
    {
        title: "Inbox",
        path: "/inbox",
        type: "App"
    },
    {
        title: "Create Position",
        path: "/?process=createPosition",
        type: "Task"
    },
    {
        title: "Create Position Budget",
        path: "/task/create-position-budget",
        type: "Task",
        description: "Create a budget for an existing position."
    },
    {
        title: "Create Position Budget Amendment",
        path: "/task/create-position-budget-amendment",
        type: "Task",
        description: "Amend an existing position budget."
    },
    {
        title: "Create Position Budget Amendment for Organization",
        path: "/task/create-position-budget-amendment-for-organization",
        type: "Task",
        description: "Amend the position budgets of a whole organization."
    },
    {
        title: "Create Position Budget Group",
        path: "/task/create-position-budget-group",
        type: "Task",
        description: "Group position budgets for reporting."
    },
    {
        title: "Create Position Budget for Organization",
        path: "/task/create-position-budget-for-organization",
        type: "Task",
        description: "Create position budgets for a whole organization."
    },
    {
        title: "Create Confidential Job Requisition",
        path: "/task/create-confidential-job-requisition",
        type: "Task",
        description: "Open a job requisition that is only visible to selected users."
    },
    {
        title: "Create Cost Center",
        path: "/?process=createCostCenter",
        type: "Task"
    },
    {
        title: "Create Cost Center Hierarchy",
        path: "/task/create-cost-center-hierarchy",
        type: "Task",
        description: "Arrange cost centers into a reporting hierarchy."
    },
    {
        title: "Benefits",
        path: "/benefits",
        type: "App"
    },
    {
        title: "Pay",
        path: "/pay",
        type: "App"
    },
    {
        title: "Absence",
        path: "/absence",
        type: "App"
    }

];

// Matches the header search: case-insensitive "contains", and an entry is
// dropped once the query has grown past its full title.
export const searchItems = (rawQuery, limit) => {
    const query = (rawQuery || "").trim().toLowerCase()
    if (!query) return []
    const shortChecker = query.substring(0, query.length - 1)
    const matches = SearchbarData.filter(item =>
        item.title.toLowerCase().includes(query) && !shortChecker.includes(item.title.toLowerCase())
    )
    return limit ? matches.slice(0, limit) : matches
}

export const findTaskBySlug = (slug) => SearchbarData.find(item => item.path === `/task/${slug}`) || null
